const {
  RootElement: wrapRootElement,
  WrapPageElement: wrapPageElement,
} = require("src/ui/templates");

exports.wrapRootElement = wrapRootElement;
exports.wrapPageElement = wrapPageElement;
